import type { Project } from '~/utils/project/Project'

/**
 * Checks if the Combo Connect modal should be closed
 * @param project Project
 * @param isLoading Whether it is loading
 * @param isModalOpen Whether the modal is open
 * @returns true if the modal should be closed
 */
export function shouldCloseComboConnectModal(
  project: Project | undefined,
  isLoading: boolean,
  isModalOpen: boolean,
): boolean {
  return !isLoading && !!project && project.complete && isModalOpen
}
